import { render } from "./home.vue?vue&type=template&id=54232a9c&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=54232a9c&scoped=true&lang=css"

import exportComponent from "F:\\VueProject\\aoying-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54232a9c"]])

export default __exports__